import React from "react";
export const Flash = () => (
  <svg viewBox="0 0 8 16">
    <path d="M0 0v8.8h2.4V16L8 6.4H4.8L7.2 0H0z" />
  </svg>
);
